export const benefits = {
  ai: 'Smart Tutor',
  ai_desc: 'Learn with a personal tutor that adapts to your needs and level',
  practice: 'Interactive Practice',
  practice_desc: 'Custom exercises designed to improve your skills',
  progress: 'Track Progress',
  progress_desc: 'Monitor your progress with detailed reports'
};